import React, { useState, useEffect } from "react";
import "./RadioBlocksExtended.css";
import Checkbox from "../Checkbox/Checkbox";
// import { usePopup } from "src/contexts/PopupContext";

type RadioBlockVariant = "default" | "square";

type RadioBlockProps = {
  block: RadioBlockInterface;
  isSelected: boolean;
  isDisabled: boolean;
  parentIsSelected?: boolean;
  showCheckbox?: boolean;
  variant?: RadioBlockVariant;
  onClick: (event: React.MouseEvent<HTMLElement>, value: string) => void;
  onSelect: (value: string) => void;
};

export interface RadioBlockInterface {
  id: number;
  name: string;
  imageUrl?: string;
  color?: string;
  value: string;
  price?: number;
  description?: string;
  component?: React.FC;
  layout?: string; // after or in_value
  selectedNames?: string;
  carouselImages?: string[];
}

interface RadioBlocksExtendedProps {
  blocks: RadioBlockInterface[];
  label?: string;
  value: string;
  disableValues?: string[];
  className?: string;
  parentIsSelected?: boolean;
  onChange: (selectedValue: string) => void;
  stopPropagation?: boolean;
  showCheckbox?: boolean;
  /** square: 2x2 cards, text top / image bottom, no details/price/extras */
  variant?: RadioBlockVariant;
}

const ArrowIcon: React.FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M16 12L10 6L8.59 7.41L13.17 12L8.59 16.59L10 18L16 12Z"
      fill="currentColor"
    />
  </svg>
);

const RadioBlock: React.FC<RadioBlockProps> = ({
  block,
  isSelected,
  isDisabled,
  parentIsSelected,
  showCheckbox,
  variant = "default",
  onClick,
  onSelect,
}) => {
  const [showDetails, setShowDetails] = React.useState(false);
  const [showComponent, setShowComponent] = React.useState(false);
  const isSquare = variant === "square";

  // const { setIsCarouselVisible, setCarouselImages } = usePopup();
  // const dispatch = useDispatch();

  const handleIconClick = (event: React.MouseEvent<HTMLElement>) => {
    if (block.carouselImages) {
      event.stopPropagation();
      // dispatch({ type: SET_CAROUSEL_IMAGES, payload: block.carouselImages });
      // dispatch({ type: SET_CAROUSEL, payload: true });
    }
  };

  const handleIconClickNopCarousel = (event: React.MouseEvent<HTMLElement>) => {
    if (block.imageUrl) {
      event.stopPropagation();
      // dispatch({ type: SET_CAROUSEL_IMAGES, payload: [block.imageUrl] });
      // dispatch({ type: SET_CAROUSEL, payload: true });
    }
  };

  const highlight =
    parentIsSelected !== undefined
      ? parentIsSelected && isSelected
      : isSelected;
  useEffect(() => {
    setShowComponent(isSelected);
  }, [isSelected]);

  if (!block.color && !block.imageUrl)
    block.color = "var(--color-primary-light)";

  const toEuroRound = (price: number) => {
    return `€ ${Math.round(price)}`;
  };

  if (isSquare) {
    return (
      <div
        key={block.id}
        className={`radio-eblock radio-eblock--square ${
          highlight ? "selected selected_bg" : ""
        }${isDisabled ? " disabled" : ""}`}
        data-value={block.value}
        onClick={(event) => {
          event.stopPropagation();
          if (!isDisabled) onClick(event, block.value);
        }}
      >
        <div className={`name ${highlight ? "selected" : ""}`}>{block.name}</div>
        <div className="icon" style={{ backgroundColor: block.color }}>
          {block.imageUrl && <img src={block.imageUrl} alt={block.name} />}
        </div>
      </div>
    );
  }

  return (
    <>
      <div
        key={block.id}
        className={`radio-eblock ${highlight ? "selected" : ""} ${
          highlight && (!showComponent || !block.component) ? "selected_bg" : ""
        }${isDisabled ? "disabled" : ""} ${
          block.layout === "in_value" ? "in_value" : ""
        }${showCheckbox ? " has-checkbox" : ""}`}
        data-value={block.value}
        onClick={(event) => {
          event.stopPropagation();
          if (isDisabled) return;
          // if (parentIsSelected === undefined || parentIsSelected)
          //   event.stopPropagation();

          if (block.component && !showComponent) {
          }
          if (!isDisabled) {
            if (isSelected) setShowComponent(!showComponent);
            // else setShowComponent(true);
          }
          if (
            event.target instanceof HTMLElement &&
            (event.target.classList.contains("simple-number-input__minus") ||
              event.target.classList.contains("simple-number-input__plus"))
          ) {
            return;
          }
          return !isDisabled && onClick(event, block.value);
        }}
      >
        <div className="radio-eblock-content">
          {showCheckbox && (
            <div
              className="checkbox-left"
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                if (isDisabled) return;
                onSelect(block.value);
              }}
            >
              <Checkbox checked={isSelected} onChange={() => {}} />
            </div>
          )}
          {/* <div className="common-option-check"></div> */}
          <div
            className={`icon${
              (block.imageUrl && !block.imageUrl.includes("empty")) ||
              block.carouselImages
                ? " cursor"
                : ""
            }`}
            style={{ backgroundColor: block.color }}
            onClick={(event) => {
              if (block.carouselImages) {
                // setCarouselImages(block.carouselImages);
                // setIsCarouselVisible(true);

                handleIconClick(event);
              } else if (block.imageUrl && !block.imageUrl.includes("empty")) {
                event.stopPropagation();

                // setCarouselImages([block.imageUrl]);
                // setIsCarouselVisible(true);\
                handleIconClickNopCarousel(event);
              }
            }}
          >
            {block.imageUrl && <img src={block.imageUrl} alt={block.name} />}
          </div>
          <div className="details_container">
            <div className="details_text">
              <div className={`name ${highlight ? "selected" : ""}`}>
                {block.name}
              </div>
              <div className="price-checkbox">
                {block.price ? (
                  <div className="price">
                    {block.price > 0 ? toEuroRound(block.price) : ""}
                  </div>
                ) : (
                  <></>
                )}
                {block.component ? (
                  <div
                    className={`details_icon ${showComponent ? "open" : ""}`}
                    onClick={(event) => {
                      setShowComponent(!showComponent);
                      event.stopPropagation();
                    }}
                  >
                    <ArrowIcon />
                  </div>
                ) : null}
              </div>
            </div>
            <div className="details_childs">
              <div className="details_childs_content">
                <span>{highlight ? block.selectedNames : null}</span>
              </div>
              <div className="details_buttons">
                {block.description && (
                  <div
                    className={`details ${showDetails ? "open" : ""}`}
                    onClick={(event) => {
                      setShowDetails(!showDetails);
                      event.stopPropagation();
                    }}
                  >
                    <span>Details</span>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        {block.description && showDetails && (
          <div className="description">{block.description}</div>
        )}
        {block.component && showComponent && (
          <div className="value">
            <div className="component">{<block.component />}</div>
          </div>
        )}
      </div>
    </>
  );
};

const RadioBlocksExtended: React.FC<RadioBlocksExtendedProps> = ({
  blocks,
  label,
  value,
  disableValues = [],
  className,
  parentIsSelected,
  onChange,
  stopPropagation = false,
  showCheckbox = false,
  variant = "default",
}) => {
  const [selectedValue, setSelectedValue] = useState(value);

  useEffect(() => {
    setSelectedValue(value);
    // setShowComponent(false);
  }, [value]);

  const selectValue = (newValue: string) => {
    if (!disableValues.includes(newValue)) {
      setSelectedValue(newValue);
      onChange(newValue);
    }
  };

  const handleBlockClick = (
    event: React.MouseEvent<HTMLElement>,
    newValue: string
  ) => {
    if (stopPropagation) event.stopPropagation();
    selectValue(newValue);
  };

  return (
    <div
      className={`radio-eblocks ${
        variant === "square" ? "radio-eblocks--square" : ""
      } ${className || ""}`.trim()}
    >
      {label && <div className="radio-eblocks-label">{label}</div>}
      {blocks.map((block) => (
        <RadioBlock
          key={block.id + block.value}
          block={block}
          isSelected={block.value === selectedValue}
          isDisabled={disableValues.includes(block.value)}
          onClick={(event: React.MouseEvent<HTMLElement>) =>
            handleBlockClick(event, block.value)
          }
          onSelect={selectValue}
          parentIsSelected={parentIsSelected}
          showCheckbox={showCheckbox}
          variant={variant}
        />
      ))}
    </div>
  );
};

export default RadioBlocksExtended;
